import React from 'react'

export default function AccountingPeriodWidget(props) {
  const { periodInfo } = props

  return (
    <>
      {periodInfo && (
        <div style={{ textAlign: 'left' }}>
          <span>{`งวดที่ ${periodInfo?.periodNumber}/${periodInfo?.periodOfLength} (${periodInfo?.startAndEndDate})`}</span>
        </div>
      )}
    </>
  )
}
